import type { ReactNode } from 'react'

import type { TypographyProps } from '@twisto/components/atoms/typography'
import { Typography } from '@twisto/components/atoms/typography'

import * as styles from './selectable-list-item-text.styles'

type Props = {
  children: ReactNode
} & TypographyProps

export const SelectableListItemText = ({ children, ...other }: Props) => (
  <Typography
    noWrap
    css={styles.text}
    data-testid="selectable-list-item-text"
    fontWeight="medium"
    variant="b3"
    {...other}
  >
    {children}
  </Typography>
)
